import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DesignAngularKitModule, ItModalComponent, ItNotificationService, NotificationPosition } from 'design-angular-kit';
import { DischargeInfo, DischargeInfoDto, RequestDto } from '../../../../models/request.dto';
import { ConfirmStructureModalComponent } from '../confirm-structure-modal/confirm-structure-modal.component';
import { StructureService } from '../../../../services/structure.service';
import { RequestService } from '../../../../services/request.service';
import { AuthService } from '../../../../services/auth.service';
import { NoteService } from '../../../../services/note.service';
import { RequestSummaryComponent } from '../../../../components/request-summary/request-summary.component';
import { CloseRequestModalComponent } from '../close-request-modal/close-request-modal.component';
import { DischargeInfoComponent } from '../discharge-info/discharge-info.component';
import { ConfirmStructureComponent } from "../../../../components/confirm-structure/confirm-structure.component";
import { FormsModule } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { InsertDischargeDateModalComponent } from "../insert-discharge-date-modal/insert-discharge-date-modal.component";
import { FacilityRefuseModalComponent } from '../facility-refuse-modal/facility-refuse-modal.component';
import { PatientRefuseModalComponent } from '../patient-refuse-modal/patient-refuse-modal.component';
import { RestartArruolamentoModalComponent } from '../../restart-arruolamento-modal/restart-arruolamento-modal.component';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';
import { UcpdomRefuseModalComponent } from '../ucpdom-refuse-modal/ucpdom-refuse-modal.component';
import { ConfirmUcpdomModalComponent } from '../confirm-ucpdom-modal/confirm-ucpdom-modal.component';

@Component({
  selector: 'app-discharge-info-action',
  standalone: true,
  imports: [CommonModule,
    DesignAngularKitModule,
    RequestSummaryComponent,
    DischargeInfoComponent,
    FormsModule,
    CloseRequestModalComponent, 
    ConfirmStructureComponent, 
    ConfirmStructureModalComponent, 
    InsertDischargeDateModalComponent,
    FacilityRefuseModalComponent,
    UcpdomRefuseModalComponent,
    ConfirmUcpdomModalComponent,
    PatientRefuseModalComponent,
    RestartArruolamentoModalComponent],
  templateUrl: './discharge-info-action.component.html',
  styleUrl: './discharge-info-action.component.scss'
})
export class DischargeInfoActionComponent {

  @Input() request!: RequestDto;
  @ViewChild('changeOwnerShipModal') changeOwnerShipModal!: ItModalComponent;
  @ViewChild('changeSettingModal') changeSettingModal!: ItModalComponent;
  @ViewChild('insertDischargeDateModal') insertDischargeDateModal!: ItModalComponent;
  @ViewChild('deleteRequestModal') deleteRequestModal!: ItModalComponent;
  @ViewChild('confirmModal') confirmModal!: ItModalComponent;
  @ViewChild('closeRequestModal') closeRequestModal!: ItModalComponent;
  @ViewChild('confirmStructureModal') confirmStructureModal!: ItModalComponent;
  @ViewChild('facilityRefuseModal') facilityRefuseModal!: ItModalComponent;
  @ViewChild('patientRefuseModal') patientRefuseModal!: ItModalComponent;
  @ViewChild('restartArruolamentoModal') restartArruolamentoModal!: ItModalComponent;
  @ViewChild('ucpdomConfirmModal') ucpdomConfirmModal!: ItModalComponent;
  @ViewChild('ucpdomRefuseModal') ucpdomRefuseModal!: ItModalComponent;
  @ViewChild('ucpdomRequestModal') ucpdomRequestModal!: ItModalComponent;

  confirmMessage = '';
  private pendingStatusChange: string | null = null;
  @Output() refreshRequest = new EventEmitter<any>();
  @Input() requestDates: DischargeInfo[] = [];
  structureTypes: any[] = [];
  structureTypesVisible: any[] = [];
  structureTypeFiltered: any[] = [];
  allTypeVisible: boolean = false;
  structures: any[] = [];
  searchTerm: string = '';
  filteredStructures: any[] = [];
  selectedStructure: any = null;
  structureRequestDate: Date | null = null;
  ucpdomRequestDate: Date | null = null;

  constructor(
    private structureService: StructureService,
    private requestService: RequestService,
    public authService: AuthService,
    private notification: ItNotificationService,
    private noteService: NoteService
  ) { }

  structureConfirmed(event: { facilityConfirmDate: Date | null }) {
    const request = {
      transitionId: this.request.id,
      typeId: '5',
      text: 'Confermata struttura '+ this.request.facility.name + ' con data confermata dalla struttura ' + format(event.facilityConfirmDate!, 'dd/MM/yyyy', { locale: it }),
      insertUserCode: this.authService.userInfo.username,
      title: 'Conferma Struttura'
    }
    this.noteService.insertNote(request).subscribe(result => {
      if(this.request.status.code === 'SS') {
        this.requestService.changeStatus(this.request.uuid, 'CS').subscribe(() => {
          this.confirmStructure(event.facilityConfirmDate);
        });
      } else {
        this.confirmStructure(event.facilityConfirmDate);
      }
      this.confirmStructureModal.toggle();
    }, error => {
      this.confirmStructureModal.toggle();
    }
    );
  }

  ucpdomConfirmed(event: { ucpdomConfirmDate: Date | null }) {
    const request = {
      transitionId: this.request.id,
      typeId: '5',
      text: 'Confermata data arruolamento ' + format(event.ucpdomConfirmDate!, 'dd/MM/yyyy', { locale: it }),
      insertUserCode: this.authService.userInfo.username,
      title: 'Conferma Arruolamento'
    }
    this.noteService.insertNote(request).subscribe(result => {
      this.confirmUcpdom(event.ucpdomConfirmDate);
      this.ucpdomConfirmModal.toggle();
    }, error => {
      this.ucpdomConfirmModal.toggle();
    }
    );
  }

  cancelledConfirmStructure() {
    this.confirmStructureModal.toggle();
  }

  cancelledConfirmUcpdom() {
    this.ucpdomConfirmModal.toggle();
  }

  cancelledChangeStructure() {
    throw new Error('Method not implemented.');
  }
  changeStructureConfirmed($event: { actorId: string; ownershipId: string; }) {
    throw new Error('Method not implemented.');
  }

  confermaPaziente() {

    const request = {
      transitionId: this.request.id,
      typeId: '5',
      text: 'Il paziente ha confermato la struttura '+ this.request?.facility?.name,
      insertUserCode: this.authService.userInfo.username,
      title: 'Conferma Paziente'
    }
    this.noteService.insertNote(request).subscribe(result => {
      if (this.request.setting.code === 'HCP' || this.request.setting.code === '26' || this.request.setting.code === 'ADI' || this.request.setting.code === 'RSA' || this.request.setting.code === 'PA' || this.request.setting.code === 'ODC') {
        this.updateRequestStatus('CST');
      } else {
        this.updateRequestStatus('CP');
      }  
    });
    
  }

  async resetStructureData() {
    const idFacilityConfirmationDate = this.requestDates.find(d => d.dateType?.code == 'DCS')?.uuid;
    const idFacilityRequestDate = this.requestDates.find(d => d.dateType?.code == 'DPS')?.uuid;
    const idDischargeDate = this.requestDates.find(d => d.dateType?.code == 'DDE')?.uuid;
    try {
      if (idFacilityConfirmationDate) {
        await firstValueFrom(this.requestService.deleteDate(idFacilityConfirmationDate));
      }
      if (idFacilityRequestDate) {
        await firstValueFrom(this.requestService.deleteDate(idFacilityRequestDate));
      }
      if (idDischargeDate) {
        await firstValueFrom(this.requestService.deleteDate(idDischargeDate));
      }
      if (this.request.setting.subSettings[0].code != 'CPD' && this.request.setting.subSettings[0].code != 'CPDMP' ) {
        await firstValueFrom(this.structureService.deleteStructureForTransition(this.request.uuid));
      }
      if (this.request.status.code == 'CS' || this.request.status.code == 'CP') {
        this.updateRequestStatus('PIC');
      // } else if (this.request.status.code != 'CPZ' && this.request.setting.code == 'ALTRO') {
      //   this.updateRequestStatus('PIC');
      } else if (this.request.status.code != 'CPZ') {
        this.updateRequestStatus('CPZ');
      } else {
        this.refreshRequest.emit();
      }
    } catch {
      //mettere alert
    }
  }

  cancelledRestartArruolamento() {
    this.restartArruolamentoModal.toggle();
  }

  async restartArruolamento() {
    this.restartArruolamentoModal.toggle();
    const request = {
      transitionId: this.request.id,
      typeId: '5',
      text: 'Ricominciato percorso di arruolamento',
      insertUserCode: this.authService.userInfo.username,
      title: 'Ricominciato percorso di arruolamento'
    }
    this.noteService.insertNote(request).subscribe(result => {
    });
    this.resetStructureData();
  }

  cancelledCompleteRequest() {
    this.insertDischargeDateModal.toggle();
  }

  insertDischargeDate(event: { dischargeDate: Date | null, dischargeTime: string|null, note: string | null }) {
    let dischargeDateTime = format(event.dischargeDate!,'yyyy-MM-dd').toString()+'T'+ event.dischargeTime+':00';
    let payload: DischargeInfoDto = {
      date: dischargeDateTime,
      operatorCode: this.authService.userInfo.username,
      transitionId: this.request.id,
      typeId: 2
    };
    if (this.requestDates && this.requestDates.find(d => d.dateType?.code == 'DDE')) {
      payload.id = this.requestDates.find(d => d.dateType?.code == 'DDE')?.id;
      this.requestService
        .updateDischargeInfo(payload)
        .subscribe(() => {
          this.insertNoteForDischargeDate(event);
        });
    } else {
      this.requestService
        .createDischargeInfo(payload)
        .subscribe(() => {
          this.insertNoteForDischargeDate(event);
        });
    }
    this.insertDischargeDateModal.toggle();
  }

  insertNoteForDischargeDate(event: { dischargeDate: Date | null, note: string | null }) {
    const request = {
      transitionId: this.request.id,
      typeId: '5',
      text: 'Aggiornamento data effettiva dimissione a '+ format(event.dischargeDate!, 'dd/MM/yyyy') + (event.note ? ' per: ' + event.note : ''),
      insertUserCode: this.authService.userInfo.username,
      title: 'Data effettiva dimissione'
    }
    this.noteService.insertNote(request).subscribe(result => {
      this.refreshRequest.emit();
    });
  }

  confirmStatusChange(status: string) {
    this.pendingStatusChange = status;
    this.confirmMessage = `Questa operazione modificherà lo stato della pratica. Vuoi procedere?`;
    this.confirmModal.toggle();
  }

  confirmStructure(facilityConfirmDate: Date | null) {
    let payload: DischargeInfoDto = {
      date: facilityConfirmDate?.toString()+'T00:00:00',
      operatorCode: this.authService.userInfo.username,
      transitionId: this.request.id,
      typeId: 4
    };
    if (this.requestDates && this.requestDates.find(d => d.dateType?.code == 'DCS')) {
      payload.id = this.requestDates.find(d => d.dateType?.code == 'DCS')?.id;
      this.requestService
        .updateDischargeInfo(payload)
        .subscribe(() => {
          this.refreshRequest.emit();
        });
    } else {
      this.requestService
        .createDischargeInfo(payload)
        .subscribe(() => {
          this.refreshRequest.emit();
        });
    }
  }

  confirmUcpdom(ucpdomConfirmDate: Date | null) {
    let payload: DischargeInfoDto = {
      date: ucpdomConfirmDate?.toString()+'T00:00:00',
      operatorCode: this.authService.userInfo.username,
      transitionId: this.request.id,
      typeId: 4
    };
    if (this.requestDates && this.requestDates.find(d => d.dateType?.code == 'DCS')) {
      payload.id = this.requestDates.find(d => d.dateType?.code == 'DCS')?.id;
      this.requestService
        .updateDischargeInfo(payload)
        .subscribe(() => {
          this.updateRequestStatus('CST');
          //this.refreshRequest.emit();
        });
    } else {
      this.requestService
        .createDischargeInfo(payload)
        .subscribe(() => {
          this.updateRequestStatus('CST');
          //this.refreshRequest.emit();
        });
    }
  }

  getStructureTypes() {
    this.structureService.getStructureTypes().subscribe((results) => {
      this.structureTypes = results;
      this.structureTypesVisible = results.filter((t: { subSettings: any[]; }) => t.subSettings.find((s: { id: number; visible: boolean; })=> s.id === this.request.setting.subSettings[0].id ));
      this.structureTypeFiltered = results.filter((t: { subSettings: any[]; }) => t.subSettings.find((s: { id: number; visible: boolean; })=> s.id === this.request.setting.subSettings[0].id ));
      if (this.structureTypesVisible.length) {
        this.structureService
          .getStructuresFromType(this.structureTypesVisible[0].code)
          .subscribe((structures) => {
            this.structures = structures;
            this.filterStructures();
          });
      }
    });
  }

  setAllVisible(allVisible: boolean) {
    this.allTypeVisible = allVisible;
    if(allVisible) {
      this.structureTypesVisible = this.structureTypes;
    } else {
      this.structureTypesVisible = this.structureTypeFiltered;
    }
  }

  getTab(event: any) {
    const index = parseInt(event.id.replace('tab_', ''), 10);
    const typeId = this.structureTypesVisible[index].code;
    this.structureService
      .getStructuresFromType(typeId)
      .subscribe((structures) => {
        this.structures = structures;
        this.filterStructures();
      });
  }

  filterStructures() {
    const term = this.searchTerm.toLowerCase();
    this.filteredStructures = this.structures.filter(
      (struct) =>
        (struct.address && struct.address.toLowerCase().includes(term)) ||
        (struct.name && struct.name.toLowerCase().includes(term))
    );
    this.selectedStructure = null;
  }

  resetFilter() {
    this.searchTerm = '';
    this.filterStructures();
  }

  selectStructure(structure: any) {
    this.selectedStructure = structure;
  }

  resetUcpdomRequest() {
    this.ucpdomRequestDate = null;
  }

  resetStructure() {
    this.allTypeVisible = false;
    this.structureTypesVisible = this.structureTypeFiltered;
  }

  onSubmitStructure() {
    if (!this.selectedStructure) {
      alert('Seleziona una struttura prima di confermare');
      return;
    }
    this.resetStructure();
    const request = {
      transitionId: this.request.id,
      typeId: '5',
      text: 'Struttura scelta: ' + this.selectedStructure.name + ' con data richiesta alla struttura ' + format(this.structureRequestDate!, 'dd/MM/yyyy'),
      insertUserCode: this.authService.userInfo.username,
      title: 'Struttura scelta'
    }
    this.noteService.insertNote(request).subscribe(result => {
      this.structureService
        .setStructureForTransition(this.request.uuid, this.selectedStructure.code)
        .subscribe((result) => {
        this.updateStructureRequestDate();
      });
    }); 
  }

  updateStatusPostDPSDate() {
    if (this.request.setting.code === 'HCP' || this.request.setting.code === '26' || this.request.setting.code === 'ADI' || this.request.setting.code === 'RSA') {
            if (this.request.status.code === 'VAL') {
              this.updateRequestStatus('CPZ', false);
            } else {
              this.refreshRequest.emit();
            }
          } else if (this.request.setting.code === 'PA' || this.request.setting.code === 'ODC') {
            if (this.request.status.code === 'TPA') {
              this.updateRequestStatus('CPZ', false);
            } else {
              this.refreshRequest.emit();
            }
          } else if (this.request.status.code === 'PIC') {
              this.updateRequestStatus('SS', false);
          } else {
            this.refreshRequest.emit();
          }
  }

  onSubmitUcpdomRequestDate() {
    const request = {
      transitionId: this.request.id,
      typeId: '5',
      text: 'Inserita data arruolamento: ' + format(this.ucpdomRequestDate!, 'dd/MM/yyyy'),
      insertUserCode: this.authService.userInfo.username,
      title: 'Struttura data arruolamento'
    }
    this.noteService.insertNote(request).subscribe(result => {
        this.updateUcpdomRequestDate();
    }); 
  }

  updateRequestStatus(status: string, noRefresh?: boolean) {
    const message =
      this.statusMessages[status] || 'Stato aggiornato con successo.';
    this.requestService.changeStatus(this.request.uuid, status).subscribe(() => {
      this.notification.success(
        'Pratica aggiornata.',
        message,
        true,
        3000,
        NotificationPosition.Top
      );
      if(!noRefresh) {
        this.refreshRequest.emit();
      }
    });
  }

  isDatePresent(dateType: string): boolean {
    return this.requestDates.find(d => d.dateType.code == dateType) ? true : false;
  }

  deleteConfirmedStructureDate(event: { note: string | null; }) {
    this.facilityRefuseModal.toggle();
    const request = {
      transitionId: this.request.id,
      typeId: '5',
      text: 'La struttura '+ this.request.facility.name +' ha rifiutato per ' + event.note,
      insertUserCode: this.authService.userInfo.username,
      title: 'Rifiuto Struttura'
    }
    this.noteService.insertNote(request).subscribe(result => {
      this.resetStructureData();
    });
  }

  deleteConfirmedUcpdomDate(event: { note: string | null; }) {
    this.ucpdomRefuseModal.toggle();
    const request = {
      transitionId: this.request.id,
      typeId: '5',
      text: 'Rifiutata data arruolamento per ' + event.note,
      insertUserCode: this.authService.userInfo.username,
      title: 'Rifiuto arruolamento'
    }
    this.noteService.insertNote(request).subscribe(result => {
      this.resetStructureData();
    });
  }

  cancelledFacilityRefuse() {
    this.facilityRefuseModal.toggle();
  }

  cancelledUcpdomRefuse() {
    this.ucpdomRefuseModal.toggle();
  }

  cancelledPatientRefuse() {
    this.patientRefuseModal.toggle();
  }

  deletePatientConfirmation(event: { note: string | null; }) {
    this.patientRefuseModal.toggle();
    const request = {
      transitionId: this.request.id,
      typeId: '5',
      text: 'Il paziente ha rifiutato la struttura '+ this.request.facility.name +' per ' + event.note,
      insertUserCode: this.authService.userInfo.username,
      title: 'Rifiuto Paziente'
    }
    this.noteService.insertNote(request).subscribe(result => {
      this.resetStructureData();
    });
  }

  updateUcpdomRequestDate() {

    let payload: DischargeInfoDto = {
      date: this.ucpdomRequestDate!.toString()+'T00:00:00',
      operatorCode: this.authService.userInfo.username,
      transitionId: this.request.id,
      typeId: 3
    };
    if (this.requestDates && this.requestDates.find(d => d.dateType?.code == 'DPS')) {
      payload.id = this.requestDates.find(d => d.dateType?.code == 'DPS')?.id;
      this.requestService
        .updateDischargeInfo(payload)
        .subscribe(() => {
          this.updateStatusPostDPSDate();
        });
    } else {
      this.requestService
        .createDischargeInfo(payload)
        .subscribe(() => {
          this.updateStatusPostDPSDate();
        });
    }

  }

  updateStructureRequestDate() {

    let payload: DischargeInfoDto = {
      date: this.structureRequestDate!.toString()+'T00:00:00',
      operatorCode: this.authService.userInfo.username,
      transitionId: this.request.id,
      typeId: 3
    };
    if (this.requestDates && this.requestDates.find(d => d.dateType?.code == 'DPS')) {
      payload.id = this.requestDates.find(d => d.dateType?.code == 'DPS')?.id;
      this.requestService
        .updateDischargeInfo(payload)
        .subscribe(() => {
          this.updateStatusPostDPSDate();
        });
    } else {
      this.requestService
        .createDischargeInfo(payload)
        .subscribe(() => {
          this.updateStatusPostDPSDate();
        });
    }

  }

  private statusMessages: { [key: string]: string } = {
    CS: 'Struttura confermata con successo.',
    DEL: 'Richiesta annullata correttamente.',
    END: 'Richiesta completata con successo.',
    CP: 'Paziente confermato con successo.',
    PIC: 'Presa in carico effettuata con successo.',
    NEW: 'Richiesta trasmessa con successo.',
  };
}
